import { createContext, useContext } from 'react';

// src/internal/auth/AuthContext.ts
var AuthContext = createContext({
  user: void 0,
  isLoading: true
});
function useAuth() {
  return useContext(AuthContext);
}

// src/internal/auth/returnTo.ts
function getSafeReturnTo(raw, options = {}) {
  const defaultPath = options.defaultPath ?? "/";
  const guestOnly = options.guestOnly ?? ["/login"];
  if (!raw) return defaultPath;
  if (!raw.startsWith("/") || raw.startsWith("//")) return defaultPath;
  const pathname = raw.split("?")[0].split("#")[0];
  if (guestOnly.some((r) => pathname === r || pathname.startsWith(r + "/"))) {
    return defaultPath;
  }
  return raw;
}

export { AuthContext, getSafeReturnTo, useAuth };
//# sourceMappingURL=chunk-LUC3HWI7.js.map
//# sourceMappingURL=chunk-LUC3HWI7.js.map